export interface Position {
	latitude: number;
	longitude: number;
	accuracy?: number;
	altitudeAccuracy?: number;
	altitude?: number;
	speed?: number;
	heading?: number;
}
